(function () {
  document.querySelectorAll('.before-after-section').forEach(function(section) {

    var slider  = section.querySelector('.ba-slider');
    var before  = section.querySelector('.ba-before');
    var divider = section.querySelector('.ba-divider');
    var range   = section.querySelector('.ba-range');

    if (!slider || !before || !divider || !range) return;

    var initialPos = parseFloat(section.dataset.initial) || 50;
    var currentPos = initialPos;
    var raf = null;

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      currentPos = pct;

      var right = (100 - pct) + '%';
      before.style.clipPath = 'inset(0 ' + right + ' 0 0)';
      divider.style.left = pct + '%';

      range.value = pct;
      range.setAttribute('aria-valuenow', Math.round(pct));
    }

    function getPct(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    slider.addEventListener('mousedown', function (e) {
      e.preventDefault();
      setPosition(getPct(e.clientX));

      function onMove(e) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          setPosition(getPct(e.clientX));
        });
      }

      function onUp() {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
      }

      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    });

    slider.addEventListener('touchstart', function (e) {
      var touch = e.touches[0];
      setPosition(getPct(touch.clientX));

      function onMove(e) {
        var t = e.touches[0];
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          setPosition(getPct(t.clientX));
        });
      }

      function onEnd() {
        slider.removeEventListener('touchmove', onMove);
        slider.removeEventListener('touchend', onEnd);
      }

      slider.addEventListener('touchmove', onMove, { passive: true });
      slider.addEventListener('touchend', onEnd);
    }, { passive: true });

    range.addEventListener('input', function () {
      setPosition(parseFloat(range.value));
    });

    setPosition(currentPos);

  });
})();